import SubregionOutlineLayer from "./SubregionOutlineLayer";
export default function SubregionOutlineWrapper(props){
  let { annotationId, node, subregionAtns } = props;

  let shouldRender = annotationId && node.c && subregionAtns 

  return shouldRender ? <SubregionOutlineLayer {...props}/> : null;

}
